import React from 'react';

import { Stack } from '@atlaskit/primitives';

import { SidePanel } from '@confluence/side-panel';

import { BulkCreateBody } from './BulkCreateBody';
import { BulkCreateHeader } from './BulkCreateHeader';
import { headerHeight } from './IssueCreateSidePanel';
import { BulkCreateFooter } from './BulkCreateFooter';

export const AiBulkDefaultView = ({ onClose }: { onClose: () => void }) => (
	<SidePanel isFixed headerHeight={headerHeight} panelTop={headerHeight}>
		<Stack>
			<BulkCreateHeader onClose={onClose} />
			<BulkCreateBody />
			<BulkCreateFooter />
		</Stack>
	</SidePanel>
);
